import React from "react";
import styled from "styled-components";
import { Container } from "react-grid-system";
import BannerFooter from "../../images/Footer/bannerFooter.PNG";
import politicPTDOC from "../../../src/assets/docs/politicPTDOC.pdf";

const Footer = ({ i18n }) => (
  <div>
    <Container fluid style={{ paddingLeft: "0", paddingRight: "0" }}>
      <FooterContent>
        <img alt="" src={BannerFooter} />
      </FooterContent>
      <FooterCenter>
        {i18n.language === "pt" && (
          <a href={politicPTDOC} target="_blank">
            Política de Privacidade
          </a>
        )}
        {i18n.language === "en" && (
          <a href={politicPTDOC} target="_blank">
            Privacy Policy
          </a>
        )}
        {i18n.language === "de" && (
          <a href={politicPTDOC} target="_blank">
            Datenschutz-Bestimmungen
          </a>
        )}
        {i18n.language === "es" && (
          <a href={politicPTDOC} target="_blank">
            Política de privacidad
          </a>
        )}
        {i18n.language === "fr" && (
          <a href={politicPTDOC} target="_blank">
            Politique de confidentialité
          </a>
        )}
        {i18n.language === "ja" && (
          <a href={politicPTDOC} target="_blank">
            プライバシーポリシー
          </a>
        )}
      </FooterCenter>
    </Container>
  </div>
);

export default Footer;

const FooterContent = styled.div`
  width: 100%;
  height: 120px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: inset 0 1px 1px 0 rgba(0, 0, 0, 0.1);

  img {
    width: auto;
    height: 80px;
  }

  @media screen and (max-width: 767px) {
    img {
      width: auto;
      height: 50px;
    }
  }
`;

const FooterCenter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;



// WEBPACK FOOTER //
// ./src/components/footer/footer.component.js